module.exports = __webpack_public_path__ + "assets/img/510068c1ed5a46d7b7418712d9b33392.svg";